module.exports = __webpack_public_path__ + "img/Astound.e73d2036.svg";